// Contrato event-driven do Vision (fonte única).
//
// A resposta do `text-ai-orchestrator` chega no browser via SSE servido pelo Rails
// (`sseVisionTransport`), que assina o JetStream interno. Os tipos de evento e os
// subjects abaixo são o contrato — trocar o transporte (ex.: mock pra dev offline)
// não muda nada fora de `visionClient.js`.

export const VISION_EVENT = Object.freeze({
  THINKING: 'thinking', // passo de raciocínio do agente
  TOOL_CALL: 'tool_call', // chamada de tool MCP — carrega `label` (display_label do registry)
  TOOL_RESULT: 'tool_result', // resultado trimado da tool
  TOKEN: 'token', // chunk da resposta final (acumula)
  DONE: 'done', // fim do turn
  ERROR: 'error', // terminal de falha (timeout do servidor ou stream interrompido)
});

// vision.{account_id}.query.request   → req/reply { session_id, query, context }
// vision.{account_id}.stream.{session} → fire-and-forget (eventos acima)
export const visionSubjects = Object.freeze({
  query: accountId => `vision.${accountId}.query.request`,
  stream: (accountId, sessionId) => `vision.${accountId}.stream.${sessionId}`,
});
